import React from 'react';

import Button from 'CommonComponents/Button';

import CircleCancelIcon from 'Assets/icons/circle-xmark.svg';
import MinusCircleIcon from 'Assets/icons/minus-circle.svg';
import TrashIcon from 'Assets/icons/trash.svg';

const BulkDeleteButtons = ({ selecting, selectedCount, itemsCount, onDelete, toggleSelecting, loading }) => {
    return (
        <div className="tw-flex tw-items-center tw-gap-4">
            <Button variant="danger" onClick={() => onDelete()} disabled={(selecting && !selectedCount) || !itemsCount || loading} loading={loading}>
                <TrashIcon className="tw-w-3.5 tw-h-3.5" />
                {selecting ? $t('Delete Selected ({{count}})', { count: selectedCount }) : $t('Delete All')}
            </Button>
            <Button variant="secondary" onClick={() => toggleSelecting()} disabled={!itemsCount || loading}>
                {selecting ? <CircleCancelIcon className="tw-w-3.5 tw-h-3.5" /> : <MinusCircleIcon className="tw-w-3.5 tw-h-3.5" />}
                {selecting ? $t('Cancel Delete') : $t('Delete Many')}
            </Button>
        </div>
    );
};

export default BulkDeleteButtons;
